import { useEffect } from "react";

interface JsonLdProps {
  /** Unique id for the script tag so we can update/remove it */
  id: string;
  /** Schema.org object (or array of objects) */
  data: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Injects a JSON-LD structured data <script> tag into <head>.
 * Used for Schema.org SEO (Product, FAQPage, BreadcrumbList, etc.)
 * Updates existing tag (by id) instead of duplicating on re-render.
 */
const JsonLd = ({ id, data }: JsonLdProps) => {
  useEffect(() => {
    const tagId = `jsonld-${id}`;
    let script = document.getElementById(tagId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = tagId;
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(data);

    return () => {
      const existing = document.getElementById(tagId);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
